import React, { useEffect, useState } from "react";
import Button from "../../../button/Button";
import Box from "../../../box/Box";
import BuyBoxFooter from "../../shared/BuyBoxFooter";
import { getUrlParameter } from "../../../utils";
import SubscriptionEligible from "./SubscriptionEligible";
import NonSubscriptionEligible from "./NonSubscriptionEligible";
import { useAddToBag } from "../../../hooks/useAddToBag";
import { ProductType } from "../../../@types/enums/ProductType";
import { ProductCategory } from "../../../@types/enums/ProductCategory";
import { PromoDiscountTypeEnum } from "onnit-ui/lib/@types/interfaces/PromoDiscountConfig";
var InStockView = function (_a) {
    var product = _a.product, freeShippingThreshold = _a.freeShippingThreshold, onSuccess = _a.onSuccess, onError = _a.onError, children = _a.children, addToBagMiddleware = _a.addToBagMiddleware, _b = _a.showFooter, showFooter = _b === void 0 ? true : _b, promoDiscountConfig = _a.promoDiscountConfig;
    var isOnSale = product.sale_discount_ratio > 0;
    var saleText = isOnSale ? "".concat((product.sale_discount_ratio * 100).toFixed(), "% off") : "";
    var isDigital = product.type_id === ProductType.DIGITAL;
    var isFitness = product.meta.category === ProductCategory.FITNESS;
    var subscriptionEligible = product.meta["subscription-eligible"] === "yes";
    var subscriptionIntervalDefault = Number(product.meta["default-subscription-frequency"]) || 30;
    var subscriptionPrice = product.price_subscription_raw || 0.0;
    var subscriptionPercentOff;
    if ((promoDiscountConfig === null || promoDiscountConfig === void 0 ? void 0 : promoDiscountConfig.promo_discounts_type) === PromoDiscountTypeEnum.SUBSCRIPTION) {
        subscriptionPrice =
            (1 - promoDiscountConfig.unit_discount_ratio) * parseFloat(product.price_msrp_raw);
        subscriptionPercentOff = promoDiscountConfig.unit_discount_ratio * 100;
    }
    var _c = useAddToBag({ onSuccess: onSuccess, onError: onError }), isAddingToBag = _c.isAddingToBag, addToBag = _c.addToBag;
    var _d = useState(subscriptionIntervalDefault), subscriptionInterval = _d[0], setSubscriptionInterval = _d[1];
    var _e = useState(function () { return subscriptionEligible; }), doSubscribe = _e[0], setDoSubscribe = _e[1];
    var _f = useState(1), quantity = _f[0], setQuantity = _f[1];
    var _g = useState(0), adjustedPrice = _g[0], setAdjustedPrice = _g[1];
    useEffect(function () {
        getUrlParameter("autosub") === "0" && setDoSubscribe(false);
    }, []);
    useEffect(function () {
        setSubscriptionInterval(Number(product.meta["default-subscription-frequency"]));
    }, [product]);
    useEffect(function () {
        var adjustedPrice = parseFloat(product.price_raw);
        if (subscriptionEligible) {
            adjustedPrice = doSubscribe ? subscriptionPrice : parseFloat(product.price_raw);
        }
        setAdjustedPrice(adjustedPrice * quantity);
    }, [product, doSubscribe, quantity]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null,
            subscriptionEligible ? (React.createElement(SubscriptionEligible, { doSubscribe: doSubscribe, setDoSubscribe: setDoSubscribe, subscriptionPrice: subscriptionPrice, subscriptionPercentOff: subscriptionPercentOff, subscriptionIntervalDefault: subscriptionIntervalDefault, subscriptionInterval: subscriptionInterval, setSubscriptionInterval: setSubscriptionInterval, saleText: saleText, product: product, quantity: quantity, setQuantity: setQuantity, isOnSale: isOnSale, isDigital: isDigital })) : (React.createElement(NonSubscriptionEligible, { product: product, quantity: quantity, setQuantity: setQuantity, isDigital: isDigital, isOnSale: isOnSale, saleText: saleText })),
            React.createElement(Button, { mt: 5, width: 1, display: "block", style: { padding: "22px 8px 18px" }, p: 0, onClick: function () {
                    var config = {
                        product_id: product.id,
                        quantity: quantity,
                        subscription_interval: doSubscribe ? subscriptionInterval : null,
                    };
                    if (addToBagMiddleware) {
                        addToBagMiddleware(config)
                            .then(function (newConfig) {
                            addToBag(newConfig);
                        })
                            .catch(console.error);
                    }
                    else {
                        addToBag(config);
                    }
                }, disabled: isAddingToBag }, isAddingToBag
                ? "Adding..."
                : "Add to Bag".concat(doSubscribe && product.meta["subscription-eligible"] === "yes"
                    ? " & Subscribe"
                    : ""))),
        children,
        showFooter && (React.createElement(BuyBoxFooter, { adjustedPrice: adjustedPrice, freeShippingThreshold: !isFitness && !isDigital ? freeShippingThreshold : null }))));
};
export default InStockView;
//# sourceMappingURL=InStockView.js.map